import React from 'react';
import withFacilities from './withFacilities';
import Editor from './Editor';

const EditorContainer = ({
  facilities,
  enabledFacilities,
  loadingFacilities,
  locale,
  onFinishEdit,
  onCancelEdit,
  ...rest
}) => {
  if (loadingFacilities) {
    return null;
  }

  return (
    <Editor
      {...rest}
      facilities={facilities}
      enabledFacilities={enabledFacilities}
      locale={locale}
      onFinishEdit={onFinishEdit}
      onCancelEdit={onCancelEdit}
    />
  );
};

EditorContainer.propTypes = {};
EditorContainer.defaultProps = {};

EditorContainer.fragments = {};

export default withFacilities(EditorContainer);
